import store from "../store";
export default async function getLocalisationPages(pages) {
    if(typeof pages == 'string') pages = [pages];
    if(typeof pages == 'object' && pages.length > 0){
        await store.dispatch('localization/pagesLocal', {pages: pages});
        let local_page_keys = await store.getters['localization/pagesLocal'];
        return local_page_keys;
    }
    return {};
}